import type { LucideIcon } from "lucide-react";

export function EmptyState({
	icon: Icon,
	title,
	description,
	action,
	className = "",
}: {
	icon?: LucideIcon;
	title: string;
	description?: string;
	action?: { label: string; onClick: () => void } | { label: string; href: string };
	className?: string;
}) {
	const actionClass =
		"inline-flex min-h-tap shrink-0 items-center rounded-md border border-hairline bg-paper px-2.5 text-xs font-medium text-ink hover:border-line hover:bg-raised";
	return (
		<div className={`flex items-center gap-3 rounded-[10px] border border-dashed border-line px-3.5 py-3 ${className}`}>
			{Icon && (
				<span className="flex size-8 shrink-0 items-center justify-center rounded-full bg-raised text-muted">
					<Icon className="size-4" aria-hidden />
				</span>
			)}
			<div className="min-w-0 flex-1">
				<p className="text-[13px] font-medium text-ink">{title}</p>
				{description && <p className="mt-0.5 text-xs text-muted">{description}</p>}
			</div>
			{action &&
				("onClick" in action ? (
					<button type="button" onClick={action.onClick} className={actionClass}>
						{action.label}
					</button>
				) : (
					<a href={action.href} className={actionClass}>
						{action.label}
					</a>
				))}
		</div>
	);
}
